import { mcars080InitRequest } from 'apis/MCARS080Api'
import { registSearchHistoryRequest } from 'apis/MCAXS010Api'
import { getMcars080Init, setMcars080Init, setOpenMCARS080, registSearchHistory} from 'reducers/entrySearchHistoryReducer'
import { openModal } from 'reducers/messageReducer'
import { all, call, put, takeEvery } from 'redux-saga/effects'

export function* getMcars080InitSaga() {
  try {
    const serverResponse = yield call(mcars080InitRequest)
    yield put(setMcars080Init(serverResponse))
    yield put(setOpenMCARS080(true))
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export function* registSearchHistorySaga(action: ReturnType<typeof registSearchHistory>) {
  try {
    yield call(registSearchHistoryRequest, action.payload)
  } catch (error) {
    yield put(openModal(error.message))
  }
}


export default function* entrySearchHistorySaga() {
  yield all([
    takeEvery(getMcars080Init, getMcars080InitSaga),
    takeEvery(registSearchHistory, registSearchHistorySaga),
  ])
}
